var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: 'w-full col-span-full ' + _vm.grid
  }, [_c('div', {
    class: _vm.passwordInputSize
  }, [_c('input-text', {
    attrs: {
      "name": "password",
      "type": "password",
      "libelle": "Changer de mot de passe",
      "new-password": true,
      "value": _vm.password,
      "error": true,
      "msg-error": ((_vm.errors || {}).password || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.$emit('fillPassword', newValue);
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-sm text-pink-600 italic mt-1.5 cursor-pointer",
    attrs: {
      "id": "change-password"
    },
    on: {
      "click": _vm.displayAuthenticateField
    }
  }, [_vm._v("\n        Modifier le mot de passe\n      ")])], 1), _vm._v(" "), _vm.isAuthenticateAsk ? _c('input-text', {
    class: _vm.confirmPasswordInputSize,
    attrs: {
      "name": "password_confirmation",
      "type": "password",
      "libelle": "Confirmer le nouveau mot de passe",
      "value": _vm.confirmPassword
    },
    on: {
      "input": function (newValue) {
        _vm.$emit('fillConfirmPassword', newValue);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.isAuthenticateAsk ? _c('input-text', {
    class: _vm.authPasswordInputSize,
    attrs: {
      "name": "authPassword",
      "type": "password",
      "libelle": "Mot de passe pour authentification",
      "placeholder": "Entrer votre mot de passe actuel",
      "value": _vm.authPassword,
      "error": true,
      "msg-error": ((_vm.errors || {}).authPassword || [])[0]
    },
    on: {
      "input": function (newValue) {
        _vm.$emit('fillAuthPassword', newValue);
      }
    }
  }) : _vm._e(), _vm._v(" "), _vm.isAuthenticateAsk ? _c('div', {
    class: _vm.confirmButtonSize
  }, [_c('div', {
    staticClass: "text-sm text-gray-600 mb-2"
  }, [_vm._v("\n \n      ")]), _vm._v(" "), _c('action-button', {
    staticClass: "mb-1",
    attrs: {
      "border-color": "border-transparent",
      "text-color": "text-white",
      "bg-color": "bg-indigo-600",
      "libelle": "Enregistrer le nouveau mot de passe",
      "uppercase": true,
      "type-shadow": "shadow-indigo"
    },
    on: {
      "clickAction": function ($event) {
        return _vm.$emit('confirmNewPassword');
      }
    }
  })], 1) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }